import { App } from "./js/App";
import React from "react";
import ReactDOM from "react-dom/client";
import styles from "./sass/styles.scss";

// const { registerObserver } = require("react-perf-devtool");
// registerObserver();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);

if (module.hot) {
  module.hot.accept();
}
